document.addEventListener("DOMContentLoaded", () => {
    AOS.init({
        startEvent: 'load',
        offset: 50,
        duration: 1000,
        once: true
    })

    var width = (window.innerWidth - 1200) / 2
    window.onresize = () => {
        width = (window.innerWidth - 1200) / 2
        $('.projectSection__slider').slick('unslick').slick({
            arrows: false,
            dots: false,
            slidesToShow: 1,
            centerMode: true,
            centerPadding: width + 'px',
            autoplay: true,
            autoplaySpeed: 10000
        })


    }
    if (document.querySelector('.projectSection')) {
        $('.projectSection__slider').slick({
            arrows: true,
            nextArrow: '.projectSection__slider__next',
            prevArrow: '.projectSection__slider__prev',
            dots: false,
            slidesToShow: 1,
            centerMode: true,
            centerPadding: width + 'px',
            autoplay: true,
            autoplaySpeed: 5000
        })
    }
    if (document.querySelector('.realizationsSection__slider')) {
        $('.realizationsSection__slider').slick({
            arrows: false,
            dots: false,
            infinite: true,
            slidesToShow: 5,
            centerMode: true,
            centerPadding: '100px',
            autoplay: true,
            autoplaySpeed: 3000,
            responsive: [
                {
                    breakpoint: 1500,
                    settings: {
                      slidesToShow: 4,
                    }
                  },
                {
                  breakpoint: 1024,
                  settings: {
                    slidesToShow: 3,
                  }
                },
                
              ]
        })
    }
    if(document.querySelector('.video-background')){
      const videos = document.querySelectorAll('.video-background')
      videos.forEach(video =>{
        var promise = video.play
        if(promise !== undefined){
          promise.catch(error=>{
            console.error('Video Autoplay Stopped!')
          }).then(()=>{
            console.info('Video started succesfully')
          })
        }
      })
    }
});